import { Component, OnInit, ViewChild } from '@angular/core';
import { authenticationSelectors } from '@microsec/ngrx-authentication';
import { AccessTokenService } from '@ids-services';
import { BaseComponent } from '@ids-components';
import { FormBuilderComponent } from '@microsec/components';
import { FormItem, User } from '@microsec/models';
import { firstValueFrom } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { OfflineTokenDetailComponent } from '../offline-token-detail/offline-token-detail.component';
import { CREATE_SUCCESS } from '@microsec/constants';

const FORM_PARAMS = {
  USERNAME: 'username',
  PASSWORD: 'password',
};

@Component({
  selector: 'app-offline-token-password-confirmation-form',
  templateUrl: './password-confirmation-form.component.html',
  styleUrls: ['./password-confirmation-form.component.scss'],
  imports: [FormBuilderComponent],
})
export class PasswordConfirmationFormComponent extends BaseComponent implements OnInit {
  fields: FormItem[] = [];

  @ViewChild('fb') form!: FormBuilderComponent;

  currentUser: User | null = null;

  constructor(private accessTokenSrv: AccessTokenService) {
    super();
  }

  async ngOnInit() {
    this.currentUser = await firstValueFrom(this.store.select(authenticationSelectors.currentUser));
    this.initForm();
  }

  /**
   * Initialize form
   */
  initForm() {
    this.fields = [
      Object.assign(new FormItem(), {
        label: 'For security purposes, please confirm your password before generating an offline token.',
        field: 'text',
        labelStyleClass: 'mb-2',
      } as FormItem),
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.USERNAME,
        defaultValue: this.currentUser?.username,
        hidden: true,
      } as FormItem),
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.PASSWORD,
        label: 'Password',
        field: 'password',
        focused: true,
        feedback: false,
        required: true,
        fieldInfo: 'Password',
      } as FormItem),
    ];
  }

  /**
   * Submit form
   * @param closeDialog
   */
  onSubmit(closeDialog: (result: any) => void) {
    const payload = { ...this.form.getRawValue() };
    const userId = this.keycloakAuthSrv.keycloakData()?.subject;
    this.accessTokenSrv
      .createOfflineToken(userId, payload)
      .pipe(
        finalize(() => {
          this.form.isLoading = false;
        }),
      )
      .subscribe({
        next: (rs: any) => {
          this.showSuccessMessage(CREATE_SUCCESS.replace('{0}', 'offline token'));
          this.openTokenDetails(rs?.offline_token);
          closeDialog(false);
        },
        error: (err: any) => {
          this.form.showServerErrorMessage(err);
          this.showErrorMessage(err);
        },
      });
  }

  /**
   * Open token details
   * @param token
   */
  openTokenDetails(token: string) {
    this.dialogSrv.open(OfflineTokenDetailComponent, {
      data: {
        token,
      },
      header: 'Offline Token',
      width: '800px',
      height: 'min-content',
      closeOnEscape: true,
    });
  }
}
